var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amendments-container"},[_c('vs-alert',{attrs:{"active":"true"}},[_vm._v(" Sie besitzen keine Zugriffsrechte für diesen Bereich. Wenden Sie sich bitte an ihren Portal-Administrator. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }